import React, { Component } from "react";

import { generatePath } from "../../../../../../../paths";

import { getImageDimensions, IGetImageDimensionsThis } from "../methods";
import { Container, Wrapper, Window } from "../shared-style";

import { Barline, In } from "./styles";
import { IProps } from "./interfaces";

class Bars extends Component<IProps> {
    state = {
        width: 0,
        height: 0,
        zoom: 1,
    };
    bars?: HTMLDivElement;
    img?: HTMLImageElement;
    constructor(props: IProps) {
        super(props);
        const { task, taskIndex, editTask } = props;
        const { data } = task;
        if (!data.bars) {
            const { systems } = data;
            let bars: number[][] = [];
            systems!.starts.forEach((start, index) => {
                bars[index] = [];
            });
            editTask({ taskIndex, changingProp: "bars", val: bars });
            setTimeout(this.save, 100);
        }
    }

    addSeparator = (index: number, startX: number) => {
        const { task, editTask, taskIndex } = this.props;
        const bars = [...task.data.bars!];
        const { zoom } = this.state;
        bars[index].push(Math.ceil(startX * zoom));
        bars[index].sort((a, b) => a - b);
        editTask({ taskIndex, changingProp: "bars", val: bars });
        this.save();
    };

    removeSeparator = (index: number, barIndex: number) => {
        const { task, editTask, taskIndex } = this.props;
        const bars = [...task.data.bars!];
        bars[index].splice(barIndex, 1);
        editTask({ taskIndex, changingProp: "bars", val: bars });
        this.save();
    };

    save = () => {
        const { task, plan, taskIndex, post } = this.props;
        const { bars } = task.data;
        post("score-editor-bars", {
            planId: plan._id,
            index: taskIndex,
            bars,
        });
    };

    render() {
        const { score, systems, bars } = this.props.task.data;
        const { width, height, zoom } = this.state;
        return (
            <Container ref={b => this.bars = b!}>
                <Wrapper>
                    <img
                        src={generatePath(score!)}
                        ref={img => this.img = img!}
                        onLoad={() => getImageDimensions.call(this as unknown as IGetImageDimensionsThis)}
                        width={width}
                        height={height}
                        alt="score"
                    />
                    {!!width &&
                        !!height &&
                        systems!.starts.map((startY, index) => (
                            <Window
                                style={{
                                    top: startY / zoom,
                                    height: systems!.height / zoom,
                                    left: 0,
                                    right: 0,
                                    cursor: "col-resize",
                                }}
                                key={index}
                                onClick={e => {
                                    this.addSeparator(
                                        index,
                                        (e.clientX - (e.target as HTMLDivElement).getBoundingClientRect().left) /
                                        (this.bars!.parentElement!.parentElement!.getBoundingClientRect().width / 1280)
                                    );
                                }}
                            >
                                {bars![index].map((bar, barIndex) => (
                                    <Barline
                                        key={barIndex}
                                        style={{
                                            height: systems!.height / zoom,
                                            left: bar / zoom,
                                        }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            this.removeSeparator(index, barIndex);
                                        }}
                                    >
                                        <In />
                                    </Barline>
                                ))}
                            </Window>
                        ))}
                </Wrapper>
            </Container>
        );
    }
}

export default Bars;
